import { Card, Col, Stack } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";
import { ArrowDown, ArrowUp } from "react-bootstrap-icons";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";

export default function TSLCard({ data, loading, error, isFullDaypart = true }) {
    return (
        <Card>
            <Card.Header className={`d-flex align-items-center px-2 ${isFullDaypart ? "" : "health-daypart-half-header"}`}>
                <span className={`offset-1 flex-grow-1`}>TSL</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>
                                <b>TSL per Session</b>- Shows average time spent listening per session.
                            </span>
                            <span>
                                <b>TSL per Listener</b>- Shows average time spent listening per listener. This data is calculated only for uniquely identifiable
                                listeners, which may not be your entire audience.
                            </span>
                            <span>Corrupted days are excluded.</span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body>
                <Stack className="d-flex flex-md-row flex-column h-100" gap={1}>
                    <Col>
                        {loading ? (
                            <LoadingIndicator width={85} />
                        ) : error ? (
                            <ErrorResponse errorCode={error} />
                        ) : (
                            <Stack>
                                <Stack direction="horizontal" className="fw-bold fs-1 text-center justify-content-center">
                                    {data.tsl_session?.time_frame && data.tsl_session?.average ? (
                                        Math.round(data.tsl_session.time_frame) > Math.round(data.tsl_session.average) ? (
                                            <ArrowUp className="text-success col-2" />
                                        ) : Math.round(data.tsl_session.time_frame) > Math.round(data.tsl_session.average) ? (
                                            <ArrowDown className="text-danger col-2" />
                                        ) : (
                                            <div className="col-2"></div>
                                        )
                                    ) : (
                                        <div className="col-2"></div>
                                    )}
                                    <span>
                                        {data.tsl_session?.time_frame
                                            ? moment.utc(moment.duration(data.tsl_session.time_frame, "s").asMilliseconds()).format("HH:mm:ss")
                                            : "--:--:--"}
                                    </span>
                                    <div className="col-2"></div>
                                </Stack>
                                <span className="text-center fs-4">per Session</span>
                                <span className="text-center text-muted fst-italic fs-6">
                                    <span>AVG </span>(
                                    {data.tsl_session?.average
                                        ? moment.utc(moment.duration(data.tsl_session.average, "s").asMilliseconds()).format("HH:mm:ss")
                                        : "--:--:--"}
                                    )
                                </span>
                            </Stack>
                        )}
                    </Col>
                    <div className="vr d-none d-md-block"></div>
                    <hr />

                    <Col>
                        {loading ? (
                            <LoadingIndicator width={85} />
                        ) : error ? (
                            <ErrorResponse errorCode={error} />
                        ) : (
                            <Stack>
                                <Stack direction="horizontal" className="fw-bold fs-1 text-center justify-content-center">
                                    {data.tsl_listener?.time_frame && data.tsl_listener?.average ? (
                                        Math.round(data.tsl_listener.time_frame) > Math.round(data.tsl_listener.average) ? (
                                            <ArrowUp className="text-success col-2" />
                                        ) : Math.round(data.tsl_listener.time_frame) < Math.round(data.tsl_listener.average) ? (
                                            <ArrowDown className="text-danger col-2" />
                                        ) : (
                                            <div className="col-2"></div>
                                        )
                                    ) : (
                                        <div className="col-2"></div>
                                    )}
                                    <span>
                                        {data.tsl_listener?.time_frame
                                            ? moment.utc(moment.duration(data.tsl_listener.time_frame, "s").asMilliseconds()).format("HH:mm:ss")
                                            : "--:--:--"}
                                    </span>
                                    <div className="col-2"></div>
                                </Stack>
                                <span className="text-center fs-4">per Listener</span>
                                <span className="text-center text-muted fst-italic fs-6">
                                    <span>AVG </span>(
                                    {data.tsl_listener?.average
                                        ? moment.utc(moment.duration(data.tsl_listener.average, "s").asMilliseconds()).format("HH:mm:ss")
                                        : "--:--:--"}
                                    )
                                </span>
                            </Stack>
                        )}
                    </Col>
                </Stack>
            </Card.Body>
        </Card>
    );
}
